import React from "react";
import * as HoverCard from "@radix-ui/react-hover-card";

export function Tooltip({ children }: { children: React.ReactNode }) {
  return (
    <HoverCard.Root>
      <React.Fragment>{children}</React.Fragment>
    </HoverCard.Root>
  );
}

Tooltip.displayName = "Tooltip";
Tooltip.Trigger = HoverCard.Trigger;
Tooltip.Content = HoverCard.Content;
Tooltip.Arrow = HoverCard.Arrow;
